import React, { useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import HowItWorks from '../components/HowItWorks';
import Footer from '../components/Footer';
import { initScrollReveal } from '../App';

const Index = () => {
  useEffect(() => {
    // Ensure animations are properly initialized when page loads
    const timer = setTimeout(() => {
      initScrollReveal();
    }, 150);

    return () => clearTimeout(timer);
  }, []);

  const handleLoginClick = (e) => {
    e.preventDefault();
    // TODO: Implement login functionality
    console.log('Login clicked');
  };

  const handleLanguageToggle = () => {
    // TODO: Implement language switching
    console.log('Language toggle clicked');
  };

  return (
    <div className="App">      
      <Header 
        onLoginClick={handleLoginClick}
        onLanguageToggle={handleLanguageToggle}
        cartCount={0}
      />
      
      <Hero />
      
      <HowItWorks />
      
      <Footer />
    </div>
  );
};

export default Index; 